package one.devsbox.www.ui.company

import androidx.compose.foundation.text.input.TextFieldState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import kotlinx.coroutines.launch
import compose.assets.Svg
import compose.assets.svg.Plus
import one.devsbox.shared.ads.SharedIO
import one.devsbox.www.io.Repository
import one.devsbox.www.ui.widgets.ScreenContentAction
import one.devsbox.www.www_portal.generated.resources.Res
import one.devsbox.www.www_portal.generated.resources.ui_company_listing_btn_add_company
import one.devsbox.www.tools.ArgsId
import tk.mallumo.compose.navigation.navTo_CompanyDUI
import tk.mallumo.compose.navigation.navTo_CompanyEUI
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.utils.DataState

@VM
class ListingCompanyVM : NavigationViewModel() {
    private lateinit var ctx: ListingCompanyCtx

    var contentActions by mutableStateOf<List<ScreenContentAction>>(emptyList())
        private set

    var state by mutableStateOf<DataState<SharedIO.Companies>>(DataState.Loading())
        private set

    var loadingMore by mutableStateOf(false)
        private set

    val search = TextFieldState()

    interface Action {
        fun loadMore()
        fun reload()
        fun openDetail(company: SharedIO.CompanySimple)
        fun createNew()
        fun back()
    }

    val action = object : Action {
        override fun loadMore() {
            val currentState = state
            if (currentState is DataState.Result && !loadingMore && currentState.nnvl.items.size < currentState.nnvl.count) {
                fetchCompanies(page = currentState.nnvl.page + 1)
            }
        }

        override fun reload() {
            fetchCompanies(0)
        }

        override fun openDetail(company: SharedIO.CompanySimple) {
            ctx.nav.navTo_CompanyDUI(ArgsId(company.id))
        }

        override fun createNew() {
            ctx.nav.navTo_CompanyEUI(ArgsId(-1L))
        }

        override fun back() {
            ctx.nav.up()
        }
    }

    fun setup(ctx: ListingCompanyCtx) {
        this.ctx = ctx
        fetchCompanies(0)
    }

    private fun fetchCompanies(page: Int) {
        if (page == 0) state = DataState.Loading()
        else loadingMore = true

        scope.launch {
            runCatching {
                Repository.ads.company.listing(page)
            }.onSuccess { response ->
                if (page == 0) {
                    state = DataState.Result(response)
                } else {
                    val current = (state as? DataState.Result)?.nnvl
                    if (current != null) {
                        state = DataState.Result(
                            current.copy(
                                page = response.page,
                                items = current.items + response.items
                            )
                        )
                    }
                }
                loadingMore = false
                setupActions()
            }.onFailure {
                if (page == 0) state = DataState.Error(it.message ?: "Unknown error")
                loadingMore = false
                contentActions = emptyList()
            }
        }
    }

    private fun setupActions() {
        contentActions = buildList {
            if (ctx.me.permission.company.write) {
                add(
                    ScreenContentAction(
                        text = Res.string.ui_company_listing_btn_add_company,
                        color = ctx.colorPrimaryContainer,
                        icon = Svg.Plus
                    ) {
                        action.createNew()
                    }
                )
            }
        }
    }

    override fun onRelease() {}
}
